module.exports = __webpack_public_path__ + "img/05-1.8f22ac4f.png";